/* eslint-disable no-plusplus */
/* eslint-disable no-console */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable func-names */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Box from '@mui/material/Box';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import CardValue from './CardValue';
import VersionStepper from './VersionStepper';
import AlertSnack from './AlertSnack';
import {
  arrayChangesAtom,
  enableChangesAtom,
  openSaveChangesDialogAtom,
  projectsDataAtom,
  selectedVersionAtom,
  openProjectNameAtom,
  mobileAtom,
} from '../Atoms';

const useStyles = makeStyles({
  row: {
    marginTop: '7vh',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

const ProjectDetails = function ProjectDetails({ idVersione }) {
  const classes = useStyles();
  const intl = useIntl();
  const [alert, setAlert] = useState(false);
  const [enableChanges, setEnableChanges] = useRecoilState(enableChangesAtom);
  const setOpenSaveChangesDialog = useSetRecoilState(openSaveChangesDialogAtom);
  const [selectedVersion, setSelectedVersion] = useRecoilState(selectedVersionAtom);
  const setArrayChanges = useSetRecoilState(arrayChangesAtom);
  const [allVersionsData, setAllVersionsData] = useState([]);
  const projectsData = useRecoilValue(projectsDataAtom);
  const openProjectName = useRecoilValue(openProjectNameAtom);
  const mobile = useRecoilValue(mobileAtom);
  let projectToShow = allVersionsData[selectedVersion];

  useEffect(() => {
    setSelectedVersion(idVersione);
  }, [idVersione]);
  useEffect(() => {
    setAllVersionsData(projectsData.filter((x) => x.Name === openProjectName));
    projectToShow = allVersionsData[selectedVersion];
  }, [projectsData, selectedVersion]);

  const internal = [
    {
      id: 'iFINECO',
      title: 'FIN-ECO',
      note: 'iFINECOnote',
      area: 'INT',
    },
    {
      id: 'iPRDLOG',
      title: 'PRD-LOG',
      note: 'iPRDLOGnote',
      area: 'INT',
    },
    {
      id: 'iTECIND',
      title: 'TEC-IND',
      note: 'iTECINDnote',
      area: 'INT',
    },
    {
      id: 'iDOCQUA',
      title: 'DOC-QUA',
      note: 'iDOCQUAnote',
      area: 'INT',
    },
    {
      id: 'iHRCOMM',
      title: 'HR-COMM',
      note: 'iHRCOMMnote',
      area: 'INT',
    },
  ];

  const external = [
    {
      id: 'eFINECO',
      title: 'FIN-ECO',
      note: 'eFINECOnote',
      area: 'EXT',
    },
    {
      id: 'ePRDLOG',
      title: 'PRD-LOG',
      note: 'ePRDLOGnote',
      area: 'EXT',
    },
    {
      id: 'eTECIND',
      title: 'TEC-IND',
      note: 'eTECINDnote',
      area: 'EXT',
    },
    {
      id: 'eDOCQUA',
      title: 'DOC-QUA',
      note: 'eDOCQUAnote',
      area: 'EXT',
    },
    {
      id: 'eHRCOMM',
      title: 'HR-COMM',
      note: 'eHRCOMMnote',
      area: 'EXT',
    },
  ];

  return (
    !mobile && (
      <Grid container className={classes.row}>
        {projectToShow &&
          //IN
          internal.map((key) => (
            <Grid item sm={2.4} xs={2.4} key={key.id}>
              <CardValue
                Id={key.id}
                Title={key.title}
                Area={key.area}
                sub="I-KPI"
                valueDefault={projectToShow[key.id]}
                setAlert={setAlert}
                notes={projectToShow[key.note]}
                idNote={key.note}
                backgroundColor="rgb(144,236,217)"
              />
            </Grid>
          ))}
        {projectToShow &&
          //OUT
          external.map((key) => (
            <Grid item sm={2.4} xs={2.4} key={key.id}>
              <CardValue
                Id={key.id}
                Title={key.title}
                Area={key.area}
                sub="E-KPI"
                valueDefault={projectToShow[key.id]}
                setAlert={setAlert}
                notes={projectToShow[key.note]}
                idNote={key.note}
                backgroundColor="rgb(54, 162, 235)"
              />
            </Grid>
          ))}
        <Grid item sm={12} xs={12}>
          {!enableChanges ? (
            <VersionStepper numberVersions={idVersione} allVersionsData={allVersionsData} />
          ) : (
            <Box
              mt={2}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                color="error"
                startIcon={<DeleteOutlineIcon />}
                variant="outlined"
                sx={{ mt: 1, mr: 1 }}
                onClick={() => {
                  setEnableChanges(false);
                  setArrayChanges([]);
                  setAlert(false);
                }}
              >
                {intl.messages.DISCARD}
              </Button>
              <Button
                color="primary"
                onClick={() => setOpenSaveChangesDialog(true)}
                startIcon={<SaveIcon />}
                variant="outlined"
                sx={{ mt: 1, mr: 1 }}
              >
                {intl.messages.CONFIRMCHANGES}
              </Button>
            </Box>
          )}
        </Grid>
        <AlertSnack severity="error" message={intl.messages.NOTES_ARE_MANDATORY} open={alert} />
      </Grid>
    )
  );
};

export default ProjectDetails;
